import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { fetchRentals } from '../actions/rentals'
import { fetchCustomerPDA } from '../actions/customers'

import Box from '../components/Box'
import ErrorMessage from '../components/ErrorMessage'
import RentalsList from '../components/RentalsList'
import RentalsFinishedList from '../components/RentalsFinishedList'
import RentalsPrerentList from '../components/RentalsPrerentList'
import LoadingProgress from '../components/LoadingProgress'
import "../styles/RentalsAdminView.css"

class RentalsView extends React.Component {
  constructor(props) {
    super(props)
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth(); // 0-indexed: 0=Jan, 7=Aug, etc.
    
    let defaultSelectedYearRange;
    if (props.category === 'BAQUEIRA') {
      // If month is less than August (i.e. 0-6), default is previous year-current year.
      defaultSelectedYearRange = currentMonth < 7
        ? `${currentYear - 1}-${currentYear}`
        : `${currentYear}-${currentYear + 1}`;
    } else {
      // For non-BAQUEIRA, default to current year
      defaultSelectedYearRange = String(currentYear);
    }

    // State to track visibility of active and finished rentals
    this.state = {
      showActiveRentals: true, // Active rentals list is visible by default
      showFinishedRentals: false, // Finished rentals list is hidden by default
      showPrerentRentals: false,
      selectedYearRange: defaultSelectedYearRange // default range
    }
  }

  componentDidMount() {
    const { role, type, id } = this.props;
    // On mount, fetch rentals using the default year range.
    const { selectedYearRange } = this.state
    const { startDate, endDate } = this.computeYearRangeDates(selectedYearRange)
    
    if (role === 'ADMIN') {
      this.props.fetchRentals(undefined, undefined, startDate, endDate, '')
    } else if (type === 'PDA') {
      this.props
        .fetchCustomerPDA(id)
        .then((response) => {
          this.props.fetchRentals(undefined, undefined, startDate, endDate, response.response.Customer)
        })
        .catch((error) => {
          console.error('Error fetching customer PDA:', error);
          this.setState({ error: 'Failed to fetch customer PDA', loading: false });
        });
    } else {
      this.props.fetchRentals(undefined, undefined, startDate, endDate, id)
    }
  }

  // Helper to generate an array of year ranges starting from 2024 up to the current year.
  generateYearRangeOptions = () => {
    const currentYear = new Date().getFullYear()
    if (this.props.category === 'BAQUEIRA') {
      const options = []
      // For each year from 2024 to currentYear, create a range like "YYYY-YYYY+1"
      for (let year = 2024; year <= currentYear; year++) {
        options.push(`${year}-${year + 1}`)
      }
      return options
    } else {
      // For non-BAQUEIRA, show individual years from 2024 to current year
      const options = []
      for (let year = 2024; year <= currentYear; year++) {
        options.push(String(year))
      }
      return options
    }
  }

  computeYearRangeDates = (yearRange) => {
    if (yearRange.includes('-')) {
      // yearRange is in the format "YYYY-YYYY"
      const [startYear, endYear] = yearRange.split('-').map(Number)
      // Fixed: start date August 1st and end date July 31st
      const startDate = `${startYear}-08-01`
      const endDate = `${endYear}-07-31`
      return { startDate, endDate }
    } else {
      // single year
      const year = Number(yearRange)
      const startDate = `${year}-01-01`
      const endDate = `${year}-12-31`
      return { startDate, endDate }
    }
  }

  handleYearRangeChange = (e) => {
    const { role, type, id } = this.props;
    const selectedYearRange = e.target.value
    this.setState({ selectedYearRange })
    const { startDate, endDate } = this.computeYearRangeDates(selectedYearRange)
    // Launch a new fetch with the new start and end dates.

    if (role === 'ADMIN') {
      this.props.fetchRentals(undefined, undefined, startDate, endDate, '')
    } else if (type === 'PDA') {
      this.props
        .fetchCustomerPDA(id)
        .then((response) => {
          this.props.fetchRentals(undefined, undefined, startDate, endDate, response.response.Customer)
        })
        .catch((error) => {
          console.error('Error fetching customer PDA:', error);
          this.setState({ error: 'Failed to fetch customer PDA', loading: false });
        });
    } else {
      this.props.fetchRentals(undefined, undefined, startDate, endDate, id)
    }
  }

  // Toggle visibility for active rentals
  toggleActiveRentals = () => {
    this.setState((prevState) => ({
      showActiveRentals: !prevState.showActiveRentals
    }))
  }

  // Toggle visibility for finished rentals
  toggleFinishedRentals = () => {
    this.setState((prevState) => ({
      showFinishedRentals: !prevState.showFinishedRentals
    }))
  }

  togglePrerentRentals = () => {
    this.setState((prevState) => ({
      showPrerentRentals: !prevState.showPrerentRentals
    }))
  }

  render() {
    const { rentals, error, loading } = this.props

    if (error) {
      return (<ErrorMessage message={error.message} />)
    }

    if (!rentals || loading) {
      return <LoadingProgress />
    }

    // Calculate the total of CANCELED rentals with PRERENT
    const totalCanceledPrerent = rentals.filter(rental => rental.Status === 'CANCELED' && rental.Name === 'PRERENT').length;

    const totalRentals = rentals.length;

    const percentageCanceledPrerent = totalRentals > 0
      ? ((totalCanceledPrerent / totalRentals) * 100).toFixed(2)
      : 0;

    return (
      <div className="rentals-admin-view">
        {/* Active rentals header */}
        <div className="rentals-admin-header">
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-calendar-alt mr-3"></i>
                <span className="text-vw-dark mr-1">RESERVAS</span>
                <span className="text-vw-light">ACTIVAS DE CLIENTE</span>
              </h1>
            </div>
            <div className="header-actions">
              <select value={this.state.selectedYearRange} onChange={this.handleYearRangeChange} className="form-control" style={{ minWidth: 160 }}>
                {this.generateYearRangeOptions().map(range => (
                  <option key={range} value={range}>Temporada {range}</option>
                ))}
              </select>
              <button className="rentals-admin-btn primary" onClick={this.toggleActiveRentals}>{this.state.showActiveRentals ? 'Ocultar' : 'Mostrar'}</button>
            </div>
          </div>
        </div>

        {this.state.showActiveRentals && <RentalsList rentals={rentals} />}

        {/* Finished rentals header */}
        <div className="rentals-admin-header" style={{ marginTop: 20 }}>
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-calendar-check mr-3"></i>
                <span className="text-vw-dark mr-1">RESERVAS</span>
                <span className="text-vw-light">FINALIZADAS DE CLIENTE</span>
              </h1>
            </div>
            <div className="header-actions">
              <button className="rentals-admin-btn primary" onClick={this.toggleFinishedRentals}>{this.state.showFinishedRentals ? 'Ocultar' : 'Mostrar'}</button>
            </div>
          </div>
        </div>

        {this.state.showFinishedRentals && <RentalsFinishedList rentals={rentals} />}

        {/* Canceled / Prerent header */}
        <div className="rentals-admin-header" style={{ marginTop: 20 }}>
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-shopping-cart mr-3"></i>
                <span className="text-vw-dark mr-1">RESERVAS</span>
                <span className="text-vw-light">CANCELADAS EN CARRITO</span>
                <span className="text-vw-dark ml-3">{totalCanceledPrerent} ({percentageCanceledPrerent}%)</span>
              </h1>
            </div>
            <div className="header-actions">
              <button className="rentals-admin-btn primary" onClick={this.togglePrerentRentals}>{this.state.showPrerentRentals ? 'Ocultar' : 'Mostrar'}</button>
            </div>
          </div>
        </div>

        {this.state.showPrerentRentals && <RentalsPrerentList rentals={rentals} />}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  rentals: state.rentals.rentals,
  error: state.rentals.error,
  loading: state.rentals.loading,
  form: state.form,
  role: state.auth.role,
  type: state.auth.type,
  category: state.auth.category,
  id: state.auth.id,
})

const mapDispatchToProps = dispatch => ({
  fetchRentals: bindActionCreators(fetchRentals, dispatch),
  fetchCustomerPDA: bindActionCreators(fetchCustomerPDA, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(RentalsView)
